import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import ButtonStyle from "./buttonstyle";
import ErrorMessage from "./errormessage";
import Form from "./form";
import Input from "./input";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Title from "./title";
import { Loader, SmallDivider } from "../shared";

const transparentButtonStyle = {
  background: "transparent",
  border: "1px solid rgba(0, 0, 0, .23)",
  borderRadius: 4,
  color: "rgba(0, 0, 0, .6)"
};

function Reference({
  form,
  setForm,
  mediaQuery,
  idx,
  email = "",
  first_name = "",
  last_name = "",
  mobile_phone = ""
}) {
  const {
    errors: { references: errors = [] }
  } = form;
  const [referenceForm, setReferenceForm] = useState({
    errors: {},
    first_name: first_name,
    last_name: last_name,
    mobile_phone: mobile_phone,
    email: email
  });
  function handleChange(change) {
    setReferenceForm(change);
    const { errors: _, ...value } = change;
    setForm({
      ...form,
      references: [...form.references.slice(0, idx), value, ...form.references.slice(idx + 1)]
    });
  }
  return (
    <div style={{ margin: "1rem" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
        <Input
          type="text"
          name="first_name"
          value={referenceForm?.first_name || ""}
          maxLength="256"
          placeholder="First name"
          form={{
            ...referenceForm,
            errors: errors[idx] || {}
          }}
          setForm={handleChange}
          style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
        />
        <Input
          type="text"
          name="last_name"
          value={referenceForm?.last_name || ""}
          maxLength="256"
          placeholder="Last name"
          form={{
            ...referenceForm,
            errors: errors[idx] || {}
          }}
          setForm={handleChange}
          style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
        />
        <Input
          type="tel"
          name="mobile_phone"
          value={referenceForm?.mobile_phone || ""}
          maxLength="64"
          placeholder="Mobile phone number"
          form={{
            ...referenceForm,
            errors: errors[idx] || {}
          }}
          setForm={handleChange}
          style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
        />
        <Input
          type="email"
          name="email"
          value={referenceForm?.email || ""}
          maxLength="255"
          placeholder="Email address"
          form={{
            ...referenceForm,
            errors: errors[idx] || {}
          }}
          setForm={handleChange}
          style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
        />
      </div>
    </div>
  );
}

function ReferenceForm({ application, mediaQuery, isLoading }) {
  const nextUrl = "/account/";
  const submitUrl = "/api/applications/v4/application/references/";
  const blankReference = { first_name: "", last_name: "", mobile_phone: "", email: "" };
  const {
    submission: {
      references: { references }
    }
  } = application;
  const [form, setForm] = useState({
    errors: { references: { non_field_errors: [] } },
    references: references
  });
  const {
    errors: { references: errors },
    errors: { references: { non_field_errors } = {} }
  } = form;
  function handleAddReference() {
    setForm({ ...form, references: [...form.references, blankReference] });
  }
  function handleDeleteReference(idx) {
    setForm({
      ...form,
      references: [...form.references.slice(0, idx), ...form.references.slice(idx + 1)]
    });
  }
  return (
    <Form
      form={form}
      setForm={setForm}
      nextUrl={nextUrl}
      showBack={false}
      submitUrl={submitUrl}
      submitLabel="Save"
      redirect={false}
    >
      {Array.isArray(errors) && errors.length > 0 && typeof errors[0] === "string" ? (
        <ErrorMessage error={{ message: errors.join(" ") }} />
      ) : null}
      {non_field_errors !== undefined && non_field_errors !== {} ? (
        <ErrorMessage error={{ message: non_field_errors.join(" ") }} />
      ) : null}
      {form.references.map((reference, idx) => (
        <div key={idx}>
          <Reference
            idx={idx}
            form={form}
            setForm={setForm}
            mediaQuery={mediaQuery}
            first_name={reference.first_name}
            last_name={reference.last_name}
            mobile_phone={reference.mobile_phone}
            email={reference.email}
          />
          <button
            onClick={() => handleDeleteReference(idx)}
            style={ButtonStyle({ enabled: true, style: transparentButtonStyle })}
          >
            - Delete
          </button>
          <SmallDivider style={{ gridColumn: "span 2" }} />
        </div>
      ))}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
        <div></div>
        <div style={{ textAlign: "right", paddingRight: "1rem" }}>
          <button
            onClick={handleAddReference}
            style={ButtonStyle({
              enabled: true,
              style: transparentButtonStyle
            })}
          >
            + Add reference
          </button>
        </div>
      </div>
    </Form>
  );
}

export default function References({ mediaQuery, page, total }) {
  const { isLoading, error, data } = useQuery(["application"]);
  const {
    results: [application]
  } = data;
  return (
    <Page>
      <PageHeader tagline="Find Your Friends">
        <P>
          Membership of The Battery is contingent upon being nominated by an active Member. We
          appreciate you filling out your application and adding references. We&apos;ll reach out to
          these folks to learn more about how you&apos;ll add to the Battery community. If one of
          them nominates you, we&apos;ll follow-up and give you an opportunity to select an open
          house to attend.
        </P>
      </PageHeader>
      <Title>References</Title>
      {isLoading || application === undefined ? (
        <Loader loading={isLoading} />
      ) : (
        <ReferenceForm application={application} mediaQuery={mediaQuery} isLoading={isLoading} />
      )}
      {error ? <ErrorMessage error={error} /> : null}
    </Page>
  );
}
